import React from 'react';
import ReportStatusBadge from '../../utils/ReportStatusBadge';
import { routesMap } from '../../routes/AppRoutes';
import { BestExecutionReport, ReportCreate } from '../../api/apiTypes';
import ReportActionLink from '../../utils/ReportActionLink';
import { Plus } from 'lucide-react';
import { showDialogNewReport } from '../../utils/dialog/showDialogFunction';

type ContainerListaReportPageProps = {
  reports: BestExecutionReport[];
  addReport: (data: ReportCreate) => Promise<void>;
};

const ContainerListaReportPage = ({ reports, addReport }: ContainerListaReportPageProps) => {

  const handleCreateNew = () => {
    showDialogNewReport(async (name, description, bankNames, referenceYear) => {
      await addReport({
        name,
        description,
        bank_names: bankNames,
        reference_year: referenceYear,
      });
    });
  };

  return (
    <div>
      <div className="flex justify-end mb-4">
        <button
          onClick={handleCreateNew}
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-[#1B365D] hover:bg-[#142a4a] transition-colors"
        >
          Crea Report
          <Plus className="w-4 h-4" />
        </button>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <div className="grid grid-cols-3 md:grid-cols-12 gap-x-4 px-6 py-3.5 border-b border-gray-100 bg-gray-50 text-xs font-semibold text-[#1B365D]">
          <div className="col-span-1 md:col-span-4">Identificativo</div>
          <div className="col-span-1 md:col-span-3">Data creazione</div>
          <div className="hidden md:block md:col-span-1">Anno</div>
          <div className="col-span-1 md:col-span-2">Stato</div>
          <div className="hidden md:block md:col-span-2" />
        </div>

        <div className="divide-y divide-gray-100">
          {reports.map((report) => (
            <div
              key={report.id}
              className="grid grid-cols-3 md:grid-cols-12 gap-x-4 px-6 py-4 hover:bg-gray-50/50 transition duration-150 items-center"
            >
              <div className="col-span-1 md:col-span-4 text-xs font-medium text-gray-800">{report.name}</div>
              <div className="col-span-1 md:col-span-3 text-xs text-gray-500">
                {new Date(report.created_at).toLocaleDateString('it-IT')}
              </div>
              {/* Null sui report creati prima della release di hardening. */}
              <div
                className="hidden md:block md:col-span-1 text-xs text-gray-500"
                title={
                  report.reference_year
                    ? "Anno di riferimento: seleziona la colonna dell'anno nel driver penetrazione mercati"
                    : "Report creato prima che l'anno di riferimento esistesse"
                }
              >
                {report.reference_year ?? '–'}
              </div>
              <div className="col-span-1 md:col-span-2">
                <ReportStatusBadge stato={report.status} />
              </div>
              <div className="col-span-1 md:col-span-2 flex justify-end">
                <ReportActionLink
                  reportId={report.id}
                  reportName={report.name}
                  toVisualizza={routesMap.VISUALIZZA_REPORT}
                  stato={report.status}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContainerListaReportPage;
